export default __webpack_public_path__ + "static/media/Sliderimg02.765dd0fd.jpg";